import React from 'react';
import './otherRestaurants.css';
import { Star, Tag } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Restaurant } from '../../../../types/restaurant';

interface OtherRestaurantsProps {
    restaurants: Restaurant[];
    currentRestId?: string;
}

const OtherRestaurants: React.FC<OtherRestaurantsProps> = ({ restaurants, currentRestId }) => {
    const navigate = useNavigate();

    // Filter out current restaurant, only show highway restaurants, and limit to a few
    const displayRestaurants = restaurants
        .filter(r => r.dbID !== currentRestId && r.isHighway === true)
        .slice(0, 5);

    if (displayRestaurants.length === 0) return null;

    const handleCardClick = (restaurant: Restaurant) => {
        // Navigate to the restaurant page
        navigate(`/prebooking/${restaurant.dbID}`);
        window.scrollTo(0, 0);
    };

    return (
        <div className="other-restaurants-container">
            <div className="other-restaurants-header">
                <h3 className="other-restaurants-title">Explore other restaurants</h3>
            </div>

            <div className="other-restaurants-scroll">
                {displayRestaurants.map(rest => (
                    <div
                        key={rest.dbID}
                        className="restaurant-card"
                        onClick={() => handleCardClick(rest)}
                    >
                        <div className="card-image-container">
                            <img
                                src={rest.image || "/placeholder-restaurant.jpg"}
                                alt={rest.name}
                                className="card-image"
                            />
                        </div>

                        <div className="card-content">
                            <div className="card-header-row">
                                <h4 className="card-res-name">{rest.name}</h4>
                                <div className="card-rating-badge">
                                    {rest.restRating || "4.2"} <Star size={10} fill="white" strokeWidth={0} />
                                </div>
                            </div>

                            <div className="card-cuisine">
                                {rest.area || "North Indian"} • {"₹1800 for two"}
                            </div>

                            <div className="card-details-row">
                                {rest.area ? `${rest.area}, ${rest.city}` : "Navi Mumbai"}
                                <span style={{ margin: '0 4px' }}>|</span>
                                2.3km
                            </div>

                            <div className="card-discount-row">
                                <div className="discount-pill">
                                    <Tag size={12} fill="white" />
                                    {rest.restDiscount || "Flat 20% OFF"}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default OtherRestaurants;
